import { Component, OnInit, ViewChild, EventEmitter, Output, Input, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as forge from 'node-forge';
import { arrayBufferToString } from '../../util/format';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-modal-certificado-cer',
  templateUrl: './modal-certificado-cer.component.html',
  styleUrls: ['./modal-certificado-cer.component.scss'],
})
export class ModalCertificadoCerComponent implements OnInit {

  @Input() corPrimaria: string;
  @Output() fecharModal = new EventEmitter();
  @ViewChild('arquivoCer') arquivoCer: ElementRef;

  formPublica: FormGroup = this.formBuilder.group({
    arquivo: new FormControl(null, Validators.required)
  });
  fileReader = new FileReader();
  certificate: any;
  state = false


  constructor(
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private loading: NgxSpinnerService,
  ) {}

  ngOnInit() {
    let self = this;
    this.fileReader.onload = (e) => {
      let contents = (<FileReader>e.target).result;
      console.log('contents', contents)
      try {
        let pkcs12Der = arrayBufferToString(contents),
          pkcs12B64 = forge.util.encode64(pkcs12Der),
          pkcs12Der64 = forge.util.decode64(pkcs12B64),
          pkcs12Asn1 = forge.asn1.fromDer(pkcs12Der64),
          pkcs12 = forge.pki.certificateFromAsn1(pkcs12Asn1),
          certificate = forge.pki.certificateToPem(pkcs12);
          console.log()
        this.fechar(certificate);
      } catch (_exception) {
        this.toast.error('Não foi possivel realizar a leitura deste arquivo');
        console.warn(_exception);
      }
    };
  }

  changeState(data) {
    console.log('data', data)
    this.state = true;
  }

  downloadTutorialCertificado() {
    this.loading.show();
    fetch('assets/docs/tutorial-certificado.pdf').then(resp => resp.blob())
      .then((async blob => {
        this.loading.hide();
        const urlBlob = window.URL.createObjectURL(blob);
        const element = document.createElement('a');
        element.setAttribute('href', urlBlob);
        element.setAttribute('download', 'tutorial-certificado.pdf');
        document.body.appendChild(element);
        element.click();
      }));
  }

  extrairChave() {
    this.loading.show()
    if (!this.arquivoCer.nativeElement) {
      this.loading.hide()
      this.toast.error('Adicione um arquivo para válidar');
      return;
    }
    var file = this.arquivoCer.nativeElement.files[ 0 ];
    console.log('file', file)
    if (file) {
      this.fileReader.readAsArrayBuffer(file);
    } else {
      this.toast.error('Não foi possivel realizar a leitura deste arquivo');
    }
    this.loading.hide()
  }

  fechar(data?) {
    this.fecharModal.emit(data);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal-certificado-cer/modal-certificado-cer.component.ts